import * as React from 'react';
import { cn } from '@/lib/utils.js';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('skeleton-shimmer rounded-md bg-muted', className)} {...props} />;
}

export { Skeleton };
